document.addEventListener("DOMContentLoaded", function () { 
  
  // hero banner start
  document.querySelectorAll('.hero-banner-logo-container a').forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default anchor behavior
      const targetId = this.getAttribute('href').substring(1); // Get the section ID
      
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth' // Smooth scrolling
        });
      }
    });
  });
  // hero banner end  
  
  // custom multicolumn start
  document.querySelectorAll('.custom-multicolumn a').forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
  // custom multicolumn end
  
  if (window.innerWidth <= 768) {
    // Loop through every .swiper container on the page
    document.querySelectorAll(".supplierSwiper").forEach(function (el) {
      // Create unique swiper instance for each container
      const swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        speed: 1000,
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: true, // stop immediately on interaction
        // },
        pagination: {
          el: el.querySelector(".swiper-pagination"), // use its own pagination
          clickable: true,
        },
      });
      
      // Add click event for pause/play toggle
      el.addEventListener("click", () => {
        const activeSlide = el.querySelector(".swiper-slide-active");
        if (activeSlide && activeSlide.classList.contains('paused-slidee')) {
          activeSlide.classList.remove('paused-slidee')
        } else {
          activeSlide.classList.add('paused-slidee')
        }  
        
        // if (swiperInstance.autoplay.running) {
        //   // swiperInstance.autoplay.stop();
        //   if (activeSlide) activeSlide.classList.add("paused-slidee");
        // } else {
        //   // swiperInstance.autoplay.start();
        //   if (activeSlide) activeSlide.classList.remove("paused-slidee");
        // }
      });
    });
  }
  
  
  
  
  if (window.innerWidth <= 768) {
    const swiper = new Swiper(".feature-grid", {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      speed: 1000,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: true,
      // },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    
    swiper.on("slideChangeTransitionEnd", function () {
      swiper.pagination.update();
    });
    
    const featureGridContainer = document.querySelector(".feature-grid");
    
    featureGridContainer?.addEventListener("click", () => {
      const activeSlide = featureGridContainer.querySelector(".swiper-slide-active");
      if (activeSlide && activeSlide.classList.contains('paused-slide')) {
        activeSlide.classList.remove('paused-slide')
      } else {
        activeSlide.classList.add('paused-slide')
      }
      
      // if (swiper.autoplay.running) {
      //   // swiper.autoplay.stop();
      //   activeSlide.classList.add("paused-slide"); // 👈 add class when stopped
      // } else {
      //   // swiper.autoplay.start();
      //   activeSlide.classList.remove("paused-slide"); // 👈 remove class when resumed
      // }
    });
  }
  
  // 3-col slider end
  
  
  // lightbox gallery homepage
  const lightbox = GLightbox({
    selector: '.glightbox'
  });
  
  const lightboxVideo = GLightbox({
    selector: '.glightbox-video'
  });
  // lightbox gallery homepage end
  
  
}); // DOMContentLoaded